export * from './finishergroupedsensor.module';
export * from './finishergroupedsensor.component';
